import React from 'react';
import ReactDOM from 'react-dom';

/**
 *
 * @param {React.ReactComponentElement} WrappedComponent - component to displace
 * @param {object} options - options object
 * @returns {React.React.ReactComponentElement} - displaced react component
 */
function displace(WrappedComponent, options) {
    if (!global.document) {
        return class EmptyDisplace extends React.Component {
            render() {
                return false;
            }
        };
    }

    options = options || {};

    class Displaced extends React.Component {
        constructor(props) {
            super(props);

            this.container = (() => {
                if (!options.renderTo) {
                    const result = document.createElement('div');
                    document.body.appendChild(result);
                    return result;
                } else if (typeof options.renderTo === 'string') {
                    return document.querySelector(options.renderTo);
                } else {
                    return options.renderTo;
                }
            })();
        }

        static defaultProps = {
            mounted: true,
        };

        static WrappedComponent = WrappedComponent;

        componentWillUnmount() {
            if (!options.renderTo) {
                this.container.parentNode.removeChild(this.container);
            }
        }

        render() {
            if (this.props.mounted === false) {
                return null;
            }
            return ReactDOM.createPortal(
                React.createElement(
                    WrappedComponent,
                    this.props,
                    this.props.children
                ),
                this.container
            );
        }
    }

    return Displaced;
}

export default displace;
